/* eslint-disable @nx/enforce-module-boundaries */
import {
  Component,
  ElementRef,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { BaseDialogStepperFormComponent } from 'admin-drivers/src/app/common/dialog/base-dialog-stepper-form';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@Component({
  selector: 't-llevo-credentials-form',
  standalone: true,
  imports: [
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatAutocompleteModule,
  ],
  templateUrl: './credentials-form.component.html',
  styles: `
    @import '../../../../utils/styles/formGroup.scss';

    form {
      mat-form-field {
        display: flex;
        width: 70% !important;
      }
    }
  `,
})
export class CredentialsFormComponent
  extends BaseDialogStepperFormComponent<FormGroup>
  implements OnChanges
{
  @ViewChild('firstInput') elementRef!: ElementRef<HTMLInputElement>;

  protected hidePassword: boolean = true;

  get password() {
    return this.frm.controls['password'];
  }

  get confirmPassword() {
    return this.frm.controls['confirmPassword']
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['focusOnFirstInput'] &&
      this.focusOnFirstInput &&
      this.loaderSrv.updatedCount > 0
    ) {
      setTimeout(() => {
        this.elementRef.nativeElement.focus();
      }, 100);
    }
  }

  protected matchPasswords() {
    const errors = this.confirmPassword.errors;
    if (this.password.value === this.confirmPassword.value) {
      if (errors && errors['PasswordNoMatch']) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { PasswordNoMatch, ...rest } = errors;
        Object.keys(rest).length > 0
        ? this.confirmPassword.setErrors(rest)
        : this.confirmPassword.setErrors(null)
      }
    } else {
      if (errors) {
        this.confirmPassword.setErrors({ ...errors, PasswordNoMatch: true });
      } else {
        this.confirmPassword.setErrors({ PasswordNoMatch: true });
      }
    }
  }
}
